import { render, staticRenderFns } from "./MakeWalletRequest.vue?vue&type=template&id=4413f796&scoped=true&"
import script from "./MakeWalletRequest.vue?vue&type=script&lang=js&"
export * from "./MakeWalletRequest.vue?vue&type=script&lang=js&"
import style0 from "./MakeWalletRequest.vue?vue&type=style&index=0&id=4413f796&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4413f796",
  null
  
)

export default component.exports